import { FormGroup } from '@angular/forms';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FiledControlTypePipe } from './pipes/field-control-type.pipe';
import { InputComponent } from '../form-controls/input/input.component';
import { SelectComponent } from '../form-controls/select/select.component';
import { RichTextComponent } from '../form-controls/rich-text/rich-text.component';
import { DatepickerComponent } from '../form-controls/datepicker/datepicker.component';
import { FormFieldControlTypeEnum } from '../../../models/office-form.model';
import { CheckboxComponent } from '../form-controls/checkbox/checkbox.component';
import { IOfficeField } from '@pages/office/models/office-data.model';
import { ControlLabelAlignment } from '@pages/office/SingleGridForm/office-form/form-controls/control-wrapper/models/control-wrapper.models';
import { FormControlConfig } from '@pages/office/office-form/office-form/form-controls/models/form-control-config.model';
import { ImageUploadComponent } from '../form-controls/image-upload/image-upload.component';

const COMPONENTS = [InputComponent, SelectComponent, RichTextComponent, DatepickerComponent, CheckboxComponent, ImageUploadComponent];

@Component({
  selector: 'app-office-form-control',
  templateUrl: 'office-form-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [...COMPONENTS, FiledControlTypePipe, CommonModule]
})
export class OfficeFormControlComponent {
  @Input({ required: true }) officeField: IOfficeField;
  @Input({ required: true }) formGroupInstance: FormGroup;
  @Input() alignment: ControlLabelAlignment;
  @Input() config: FormControlConfig;

  readonly formFieldControlTypeEnum = FormFieldControlTypeEnum;
}
